import * as React from 'react';
import { SBChatShow, SBChatAssistant } from '../../../../domains/messaging/stores/SBChatStore';
import { assistantWidget } from '../../../../domains/assistant/stores/assistantStore';
import type { TourDefinition } from '../types';

/**
 * Tracks whether the tour is what opened the chat panel, so exiting doesn't
 * yank the panel shut on someone who already had it open.
 */
let openedByTour = false;

export const didiIntroTour: TourDefinition = {
  key: 'didi_intro',
  version: 1,
  audience: (ctx) => ctx.isPractice && ctx.didiEnabled,
  startDelayMs: 1500,
  steps: [
    {
      id: 'nav_chat',
      anchor: '[data-tour="nav-chat"]',
      placement: 'bottom',
      title: 'Meet DiDi, your hiring assistant',
      body: 'DiDi lives in your Chat panel. Ask for what you need in plain English and DiDi does the work.',
    },
    {
      id: 'didi_row',
      beforeShow: () => {
        if (!SBChatShow.get()) {
          openedByTour = true;
          SBChatShow.set(true);
        }
      },
      anchor: '[data-tour="didi-row"]',
      placement: 'left',
      anchorTimeoutMs: 5000,
      title: 'Pinned above your conversations',
      body: 'DiDi sits at the top of your message list, always one click away.',
    },
    {
      id: 'capabilities',
      beforeShow: () => {
        SBChatAssistant.set(true);
        // activePanel persists in sessionStorage, so a user who last left DiDi
        // on the history list would otherwise land there — no chips to point
        // at. Put the panel in a known state rather than inheriting one.
        assistantWidget.setKey('activePanel', 'chat');
      },
      anchor: '[data-tour="didi-chips"]',
      placement: 'top',
      anchorTimeoutMs: 5000,
      onMissingAnchor: 'center',
      title: 'Four things DiDi can do',
      body: (
        <ul className="dd-tour__list">
          <li><strong>Post a job:</strong> DiDi walks you through it and creates the draft.</li>
          <li><strong>Search candidates:</strong> describe the role, get matching professionals.</li>
          <li><strong>View applicants:</strong> see who applied and where they are.</li>
          <li><strong>Manage jobs:</strong> check, edit, or close your active postings.</li>
        </ul>
      ),
    },
    {
      id: 'ask_anything',
      anchor: '[data-tour="didi-composer"]',
      placement: 'top',
      onMissingAnchor: 'center',
      title: 'Or just type what you need',
      body: 'Try "show me my applicants from last week" or "post a hygienist role in Sacramento".',
    },
  ],
  onExit: () => {
    SBChatAssistant.set(false);
    if (openedByTour) {
      SBChatShow.set(false);
      openedByTour = false;
    }
  },
};

export default didiIntroTour;
